import core, { View } from '@gin-betting/core';
import matchList from '@gin-betting/match-list';
import createCachedSelector from 're-reselect';

const {
    entities: {
        selectors: { selectMarkets, selectMatchIdFromProps },
    },
} = core;

const {
    selectors: { selectTopMarketIdsByMatchId },
} = matchList;

export const selectTopMarketsByMatchId = createCachedSelector(
    selectTopMarketIdsByMatchId,
    selectMarkets,
    (marketIds, markets): View.Market[] => {
        if (!marketIds) return [];

        return (
            marketIds
                .toArray()
                .filter(marketId => markets.has(marketId))
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                .map(marketId => markets.get(marketId)!)
        );
    }
)(selectMatchIdFromProps);
